









































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { ConsultaColetivaAdicionaFormData } from '../../../../back/src/types';

import CustomDialog from '../CustomDialog.vue';
import PacienteConsultaColetivaMiniCard from '../pacientes/PacienteConsultaColetivaMiniCard.vue';
import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';

export default Vue.extend({
  name: 'ConsultaColetivaAddPacienteDialog',
  props: {
    pacientesConsultaColetiva: {
      default: [],
    },
    consultaColetiva: {
      default: null,
    },
  },
  components: {
    CustomDialog,
    PacienteConsultaColetivaMiniCard,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      pacientesSelecionadas: [],
      pacientes: [],
      rules: {
        arrayRequired: [
          (v: any[]) => v.length > 0 || 'Selecione as participantes',
        ],
      },
    };
  },
  mounted() {
    this.getPacientes();
  },
  computed: {
    formAdicionaPacientes(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formAdicionaPacientes as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean,
      };
    },
    pacientesFiltradas() {
      if (this.pacientes.length === 0) return [];
      const pacientesIds = _.map(this.pacientesConsultaColetiva, paciente => paciente.id);
      return _.filter(this.pacientes, el => !pacientesIds.includes(el.id));
    },
  },
  methods: {
    async getPacientes(): Promise<void> {
      this.loading = true;
      const response = await Requester.paciente.pacientesGestantes();
      if (response.errors.length > 0) {
        this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
      } else {
        this.pacientes = response.data;
      }
      this.loading = false;
    },
    removePacienteSelecionada(pacienteId) {
      const index = _.findIndex(this.pacientesSelecionadas as Paciente[],
        paciente => paciente.id === pacienteId);
      if (index >= 0) this.pacientesSelecionadas.splice(index, 1);
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      if (!this.formAdicionaPacientes.validate()) {
        return;
      }
      this.loading = true;
      const formData: ConsultaColetivaAdicionaFormData = {
        id: this.consultaColetiva.id,
        pacientes_ids: _.map(this.pacientesSelecionadas, el => Number(el.id)),
      };
      try {
        const response = await Requester.consultaColetiva.adicionaPacienteConsultaColetiva(
          formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('getConsultaColetiva');
          this.pacientesSelecionadas.splice(0, this.pacientesSelecionadas.length);
          this.dialog = false;
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Paciente(s) adicionada(s) com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
